import { orderSetStepMemberId } from "@repo/data-store";
import { resolvePlacement, StepPlacement, settle } from "@repo/domain";
import type { PresentedOrderSetDto } from "@/lib/order-set-presentation";

/** The booked proposal counterpart of OrderSet.splitOrder. */
export function splitProcedureInOrderSet(set: PresentedOrderSetDto, orderId: string): PresentedOrderSetDto {
  const source = set.steps.findIndex((step) => step.orders.some((order) => order.orderId === orderId));
  const step = set.steps[source];
  const order = step?.orders.find((order) => order.orderId === orderId);
  if (
    !order ||
    !step ||
    order.status === "completed" ||
    order.status === "revoked" ||
    step.orders.filter((item) => item.status !== "revoked").length < 2
  )
    return set;
  const high = Math.max(
    set.stepIdHigh ?? 0,
    ...set.steps.map((step) => Number(orderSetStepMemberId(step.stepId).slice(5)) || 0),
  );
  const steps = set.steps.map((step, index) => ({
    ...step,
    placement: new StepPlacement(step.placement),
    orders: index === source ? step.orders.filter((item) => item.orderId !== orderId) : [...step.orders],
  }));
  steps.splice(source + 1, 0, {
    stepId: `step-${high + 1}`,
    placement: resolvePlacement({
      offsetMinutes: new StepPlacement(step.placement).endMinutes,
    }),
    orders: [order],
  });
  return {
    ...set,
    stepIdHigh: high + 1,
    steps: settle(steps, source + 1).map(({ placement, ...step }) => ({
      ...step,
      placement: { offsetMinutes: placement.offsetMinutes, durationMinutes: placement.durationMinutes },
    })),
  };
}
